<script setup>
import { useRegionStore } from '@/store/regions'
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import RegionPlugin from '../CanvasPluginProviders/RegionPlugin.ts'

const props = defineProps({
  pluginConfig: { type: Object, default: () => ({}) },
  plugin: { type: RegionPlugin, default: null },
})
const emit = defineEmits(['update:pluginConfig', 'toggleRegionsOverlay'])

const { mobile } = useDisplay()

const regionTypes = computed(() => {
  const types = useRegionStore().getRegionTypes()
  if (!types) return []
  return Object.keys(types)
})

const regionType = ref(props.pluginConfig.regionType || regionTypes.value[0])
const regionOpacity = ref(40)

function updatePluginConfig() {
  emit('update:pluginConfig', {
    ...props.pluginConfig?.regions,
    enabled: props.pluginConfig?.regions?.enabled ?? true,
    regionType: regionType.value ?? regionTypes.value[0],
    regionOpacity: regionOpacity.value ?? 40,
  })
}
</script>

<template>
  <v-layout-card
    v-if="plugin && plugin.isEnabled && plugin.isEnabled() && !plugin.config.hideRegionsOverlay"
    class="px-4 py-3 position-absolute"
    style="top: 84px; left: 16px"
    width="100%"
    :max-width="mobile ? '370px' : '420px'"
  >
    <div class="d-flex flex-column ga-6">
      <div>
        <div class="d-flex flex-row justify-space-between align-center">
          <div class="d-flex align-center ga-2">
            <v-icon
              icon="mdi-vector-square"
              size="large"
            />
            <v-card-title class="px-0">
              {{ $t('canvas.settings.overlay.regions.title') }}
            </v-card-title>
          </div>
          <v-btn
            icon="mdi-close"
            size="small"
            variant="plain"
            class="rounded-circle"
            @click="$emit('toggleRegionsOverlay', true)"
          />
        </div>
        <v-card-subtitle class="px-0">
          {{ $t('canvas.regions_subtitle_with_count', { count: regionTypes.length }) }}
        </v-card-subtitle>
      </div>

      <v-autocomplete
        v-model="regionType"
        width="100%"
        prepend-icon="mdi-selection-marker"
        :label="$t('canvas.settings.overlay.regions.type')"
        variant="outlined"
        hide-details
        :items="regionTypes"
        @update:model-value="updatePluginConfig"
      />
      <div v-if="pluginConfig?.regions?.enabled">
        <v-label>
          {{ $t('canvas.settings.overlay.regions.opacity') }}
        </v-label>
        <v-slider
          v-model="regionOpacity"
          class="ma-2 mt-0"
          prepend-icon="mdi-opacity"
          hide-details
          :max="100"
          :min="25"
          :step="1"
          @end="updatePluginConfig"
        />
      </div>
    </div>
  </v-layout-card>
</template>
